import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AuthService } from 'src/app/auth/auth.service';
import { UserInterface } from 'src/app/types/user';
import { environment } from 'src/environments/environment';
import * as Bowser from 'bowser';

interface FormInterface {
  embed: string;
  type: string;
  allowPublicEntries?: boolean;
}

if (typeof window !== 'undefined') {
  window.formSubmitted = () => {
    setTimeout(() => {
      if (typeof document !== 'undefined') {
        document.getElementById('formTop').scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, 0);
  };
}

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit {
  cordova: boolean = false;
  isBrowser: boolean = false;
  user: UserInterface;
  authRequired: boolean = true;
  formEmbed: string;
  formEmbedType: string;
  browserName: string;

  @Input() publicForm: boolean = false;
  @Input() node: FormInterface;
  @Input() formTitle: string = '';

  constructor(
    private platform: Platform,
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.platform.ready().then(() => {
      this.cordova = this.platform.is('cordova');
    });

    this.authService.dataChange.subscribe((user) => {
      if (this.isBrowser && !this.cordova) {
        this.user = user;

        if (!this.publicForm) {
          this.authRequired = true;
        }
        this.setFormPrefill();
      }
    });
  }

  checkBrowserPlatform() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    this.browserName = browser.getBrowserName();
  }

  setFormPrefill() {
    if (this.user) {
      const mallOptIn = this.user.optIns
        ? this.user.optIns.filter((k) => k.id === environment.mall_id)[0].optIn
        : false;

      this.formEmbed = this.node.embed.replace(
        '>',
        `onsubmit="formSubmitted" data-prefill="firstName=${this.user.firstName ? encodeURIComponent(this.user.firstName) : ''
        }&lastName=${this.user.lastName ? encodeURIComponent(this.user.lastName) : ''
        }&email=${encodeURIComponent(this.user.email)}&phone=${this.user.mobile ? encodeURIComponent(this.user.mobile) : ''
        }&mallOptin=${mallOptIn ? 'Yes' : 'No'}&mallId=${environment.mall_id
        }&mallName=${environment.environment_title}&browser=${this.browserName
        }&deviceSource=${this.platform.platforms()[0]}"`
      );

      this.authRequired = false;
    } else {
      this.formEmbed = this.node.embed.replace(
        '>',
        `onsubmit="formSubmitted" data-prefill="mallOptin=No&mallId=${environment.mall_id
        }&mallName=${environment.environment_title}&deviceSource=${this.platform.platforms()[0]
        }&browser=${this.browserName}"`
      );
    }
  }

  saveCurrentRoute(link) {
    this.authService.setRedirectUrl(this.router.url);
    this.router.navigateByUrl(link);
  }

  string_between_strings(startStr, endStr, str) {
    const pos = str.indexOf(startStr) + startStr.length;
    return str.substring(pos, str.indexOf(endStr, pos));
  }

  ngOnInit() {
    if (
      this.node?.embed.includes('canal-walk-entertain-cw-application-form') ||
      this.node?.allowPublicEntries ||
      this.node?.embed.includes('allow-public-entries')
    )
      this.publicForm = true;

    if (this.publicForm) this.authRequired = false;

    // Check for stored SSO profile
    if (this.isBrowser && !this.cordova) {
      this.formEmbed = this.node?.embed;
      if (this.formEmbed.includes('paperform')) {
        this.formEmbedType = 'paperform';
      } else if (this.formEmbed.includes('surveymonkey')) {
        this.formEmbedType = 'surveymonkey';
      } else if (this.formEmbed.includes('iframe')) {
        this.formEmbedType = 'iframe';
      } else if (this.formEmbed.includes('nter')) {
        this.formEmbedType = 'nter';
      }

      this.user = this.authService.getUser();

      if (!this.publicForm) {
        this.authRequired = true;
      }

      this.checkBrowserPlatform();
      if (this.formEmbedType == 'paperform') this.setFormPrefill();
    }
  }
}
